<template>
  <div class="login-wrapper">
    <div class="login-card">
      <!-- LEFT: Forget Password Form -->
      <div class="login-form">
        <div class="text-center mb-4">
          <img
            src="/church/one.png"
            alt="Boston Logo"
            class="img-fluid logo"
          >
        </div>
        <h2 class="main-heading">Forgot Password</h2>
        <p class="subtitle">Enter your email address to reset your password</p>

        <form @submit.prevent="onSubmit">
          <div class="form-group">
            <label for="email" class="form-label">Email Address</label>
            <input
              type="email"
              id="email"
              class="form-control"
              placeholder="Enter your email address"
              v-model="form.email"
              required
            >
          </div>

          <div class="form-options">
            <div></div>
            <router-link to="/church_login" class="forgot-link">
              Back to Login?
            </router-link>
          </div>

          <button type="submit" class="btn-primary" :disabled="loading">
            {{ loading ? 'Sending...' : 'Send Reset Link' }}
          </button>

          <p class="signup-text">
            Need help? Contact us at
            <a :href="'mailto:' + support_email" class="signup-link">
              {{ support_email }}
            </a>
          </p>
        </form>

        <div v-if="errors.invalid" class="alert alert-danger">
          {{ errors.invalid }}
        </div>
      </div>

      <!-- RIGHT: Info + Video -->
      <div class="info-panel">
        <h3>Reset Your Password Securely</h3>
        <p>
          We'll send a secure password reset link to your email address.
          Follow the instructions in the email to create a new password and regain access to your account.
          If you don't receive the email, please check your spam folder or contact support.
        </p>
        <div class="video-wrapper">
          <img
            src="/church/three.png"
            alt="Security thumbnail"
          >
          <!-- Play button triggers modal -->
          <!-- <button
            type="button"
            class="play-btn"
            @click="showVideoModal = true"
          >
            <div class="play-icon"></div>
          </button> -->
        </div>
      </div>
    </div>

    <!-- Custom Video Modal -->
    <div v-if="showVideoModal" class="video-modal-overlay" @click="closeModal">
      <div class="video-modal-content" @click.stop>
        <button class="modal-close-btn" @click="closeModal">&times;</button>
        <div class="video-container">
          <iframe
            :src="videoSrc"
            title="Password Security Video"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";
import { Dynamic } from "../../wl";

export default {
  name: 'BostonForgetPassword',
  data() {
    return {
      loading: false,
      showVideoModal: false,
      form: {
        email: ""
      },
      errors: {
        invalid: ""
      },
      support_email: ""
    };
  },
  computed: {
    videoSrc() {
      // return this.showVideoModal
      //   ? "https://www.youtube.com/embed/dQw4w9WgXcQ?autoplay=1"
      //   : "https://www.youtube.com/embed/dQw4w9WgXcQ?autoplay=0";

       return this.showVideoModal
        ? "https://www.youtube.com/embed/5-_uYyVlxrk?autoplay=1"
        : "https://www.youtube.com/embed/5-_uYyVlxrk?autoplay=0";
    }
  },
  mounted() {
    document.querySelector('title').textContent = "Church’s Chicken";

    // Handle escape key to close modal
    document.addEventListener('keydown', this.handleEscapeKey);
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.handleEscapeKey);
  },
  created() {
    this.support_email = Dynamic.SUPPORT_EMAIL;
  },
  methods: {
    closeModal() {
      this.showVideoModal = false;
    },
    handleEscapeKey(event) {
      if (event.key === 'Escape' && this.showVideoModal) {
        this.closeModal();
      }
    },
    onSubmit() {
      this.loading = true;
      this.errors.invalid = "";

      this.$http
        .post("user/resetLink", {
          user_name: this.form.email
        })
        .then(resp => {
          this.form.email = ""; // Clear the input field after successful submission
          Swal.fire({
            html: resp.data.message,
            icon: "success",
            confirmButtonClass: "btn btn-success btn-fill"
          });
        })
        .catch(function (error) {
          Swal.fire({
            title: "Error!",
            html: error.response.data.message,
            icon: "error"
          });
        })
        .finally(() => (this.loading = false));
    }
  }
};
</script>

<style scoped>
.login-wrapper {
  min-height: 100vh;
  font-family: 'Nunito', sans-serif;
  background: url('/church/two.png') no-repeat center/cover;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  position: relative;
}

.main-heading {
  font-size: 1.75rem;
  color: black;
  font-weight: 700;
  margin-bottom: 0.5rem;
}

.login-wrapper::before {
  content: "";
  position: absolute;
  inset: 0;
  background-color: rgba(255, 255, 255, 0.1);
}

.login-card {
  max-width: 900px;
  width: 100%;
  border-radius: 0.5rem;
  overflow: hidden;
  box-shadow: 0 0.5rem 1.5rem rgba(0,0,0,0.3);
  display: flex;
  flex-wrap: wrap;
  position: relative;
  z-index: 1;
}

.login-form {
  flex: 1 1 300px;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  padding: 2.5rem 1.5rem;
}

.text-center {
  text-align: center;
}

.mb-4 {
  margin-bottom: 1.5rem;
}

.logo {
  max-height: 60px;
  width: auto;
}

.img-fluid {
  max-width: 100%;
  height: auto;
}

.login-form h2 {
  font-size: 1.5rem;
  margin-bottom: 0.5rem;
  text-align: center;
  color: black;
  font-weight: 400;
}

.subtitle {
  text-align: center;
  color: #666;
  margin-bottom: 1.5rem;
  font-size: 1.2;
}

.form-group {
  margin-bottom: 1rem;
}

.form-label {
  display: block;
  font-weight: 300;
  margin-bottom: 0.5rem;
}

.form-control {
  width: 100%;
  border-radius: 4px;
  padding: 0.75rem;
  background: rgba(255, 255, 255, 0.9);
  font-size: 1rem;
  transition: all 0.3s ease;
}

.form-control:focus {
  outline: none;
  border-color: #2D2926;
  box-shadow: 0 0 0 0.2rem rgba(19, 44, 90, 0.25);
  background: rgba(255, 255, 255, 0.95);
}

.form-control::placeholder {
  color: #132c5a;
  opacity: 0.7;
}

.form-options {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-left: 21px;
}

.forgot-link,
.signup-link {
  color: #2D2926;
  text-decoration: none;
  font-weight: 300;
  font-size: 0.9rem;
}

.forgot-link:hover,
.signup-link:hover {
  color: #2D2926;
  text-decoration: underline;
}

.btn-primary {
  background-color: #F79C18;
  border: none;
  color: #fff;
  width: 100%;
  padding: 0.75rem;
  border-radius: 0.25rem;
  font-size: 1rem;
  font-weight: 300;
  cursor: pointer;
  transition: background-color 0.3s ease;
  margin-bottom: 1rem;
}

.btn-primary:hover:not(:disabled) {
  background-color: #F79C18;
}

.btn-primary:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.signup-text {
  text-align: center;
  font-size: 0.9rem;
  color: #666;
  margin: 0;
}

.info-panel {
  flex: 1.2 1 300px;
  background-color: #2D2926;
  color: #fff;
  padding: 2.5rem 1.5rem;
}

.info-panel h3 {
  font-size: 1.25rem;
  margin-bottom: 0.75rem;
  font-weight: 300;
  color: #fff;
}

.info-panel p {
  font-size: 0.9rem;
  line-height: 1.6;
  margin-bottom: 1.5rem;
  opacity: 0.9;
}

.video-wrapper {
  position: relative;
  width: 100%;
  padding-top: 56.25%; /* 16:9 */
  border-radius: 0.5rem;
  overflow: hidden;
  background: #333;
}

.video-wrapper img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.play-btn {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 60px;
  height: 60px;
  background: rgba(255,255,255,0.9);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: none;
  transition: all 0.3s ease;
}

.play-btn:hover {
  background: rgba(255,255,255,1);
  transform: translate(-50%, -50%) scale(1.1);
}

.play-icon {
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 12px 0 12px 20px;
  border-color: transparent transparent transparent #132c5a;
  margin-left: 4px;
}

/* Custom Modal Styles */
.video-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 1rem;
}

.video-modal-content {
  position: relative;
  width: 100%;
  max-width: 800px;
  background: transparent;
  border-radius: 0.5rem;
  overflow: hidden;
}

.modal-close-btn {
  position: absolute;
  top: -40px;
  right: 0;
  background: none;
  border: none;
  color: white;
  font-size: 2rem;
  cursor: pointer;
  z-index: 1001;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-close-btn:hover {
  opacity: 0.7;
}

.video-container {
  position: relative;
  width: 100%;
  padding-top: 56.25%; /* 16:9 */
}

.video-container iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: none;
  border-radius: 0.5rem;
}

.alert {
  padding: 0.75rem 1rem;
  margin-top: 1rem;
  border-radius: 0.25rem;
}

.alert-danger {
  background-color: #f8d7da;
  border: 1px solid #f5c6cb;
  color: #721c24;
}

@media (max-width: 767px) {
  .info-panel {
    order: 1;
    margin-top: 1rem;
  }

  .login-form,
  .info-panel {
    padding: 1.5rem 1rem;
  }

  .login-wrapper {
    padding: 0.5rem;
  }

  .form-options {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.75rem;
  }
}

@media (max-width: 576px) {
  .login-form h2 {
    font-size: 1.25rem;
  }

  .logo {
    max-height: 50px;
  }

  .video-modal-content {
    margin: 0 0.5rem;
  }

  .modal-close-btn {
    top: -35px;
    font-size: 1.5rem;
  }
}
</style>
